/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addDivision } from '../fn/divisions/add-division';
import { AddDivision$Params } from '../fn/divisions/add-division';
import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';
import { DivisionDto as DigiworkMaitreDPosDtoDivisionDto } from '../models/Digiwork/MaitreD/Pos/DTO/division-dto';
import { DivisionsDto as DigiworkMaitreDPosDtoDivisionsDto } from '../models/Digiwork/MaitreD/Pos/DTO/divisions-dto';
import { getDivision } from '../fn/divisions/get-division';
import { GetDivision$Params } from '../fn/divisions/get-division';
import { getDivisions } from '../fn/divisions/get-divisions';
import { GetDivisions$Params } from '../fn/divisions/get-divisions';
import { removeDivision } from '../fn/divisions/remove-division';
import { RemoveDivision$Params } from '../fn/divisions/remove-division';
import { updateDivision } from '../fn/divisions/update-division';
import { UpdateDivision$Params } from '../fn/divisions/update-division';

@Injectable({ providedIn: 'root' })
export class DivisionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDivisions()` */
  static readonly GetDivisionsPath = '/api/divisions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDivisions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDivisions$Response(params?: GetDivisions$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoDivisionsDto>> {
    return getDivisions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDivisions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDivisions(params?: GetDivisions$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoDivisionsDto> {
    return this.getDivisions$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoDivisionsDto>): DigiworkMaitreDPosDtoDivisionsDto => r.body)
    );
  }

  /** Path part for operation `addDivision()` */
  static readonly AddDivisionPath = '/api/divisions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addDivision()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addDivision$Response(params?: AddDivision$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>> {
    return addDivision(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addDivision$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addDivision(params?: AddDivision$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoDivisionDto> {
    return this.addDivision$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>): DigiworkMaitreDPosDtoDivisionDto => r.body)
    );
  }

  /** Path part for operation `getDivision()` */
  static readonly GetDivisionPath = '/api/divisions/{divisionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDivision()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDivision$Response(params: GetDivision$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>> {
    return getDivision(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDivision$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDivision(params: GetDivision$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoDivisionDto> {
    return this.getDivision$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>): DigiworkMaitreDPosDtoDivisionDto => r.body)
    );
  }

  /** Path part for operation `updateDivision()` */
  static readonly UpdateDivisionPath = '/api/divisions/{divisionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDivision()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDivision$Response(params: UpdateDivision$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>> {
    return updateDivision(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDivision$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDivision(params: UpdateDivision$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoDivisionDto> {
    return this.updateDivision$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>): DigiworkMaitreDPosDtoDivisionDto => r.body)
    );
  }

  /** Path part for operation `removeDivision()` */
  static readonly RemoveDivisionPath = '/api/divisions/{divisionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeDivision()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeDivision$Response(params: RemoveDivision$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return removeDivision(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeDivision$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeDivision(params: RemoveDivision$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.removeDivision$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

}
